/* tm-halloween : déco Halloween. Lit les réglages de la section « Déco Halloween (tm-) »
   (élément #tm-halloween-config) puis construit les effets. Sans réglage = rien ne s'affiche. */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var state = { resizeObserver: null, resizeTimer: null, sparkHandler: null, lastSpark: 0 };

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function seeded(seed) {
    var t = seed >>> 0;
    return function () {
      t += 0x6d2b79f5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html) node.innerHTML = html;
    return node;
  }

  function readConfig() {
    var node = document.getElementById('tm-halloween-config');
    if (!node) return null;
    var d = node.dataset;
    var on = function (key) {
      return d[key] !== 'false';
    };
    return {
      webs: on('webs'),
      spiders: on('spiders'),
      bats: on('bats'),
      witch: on('witch'),
      fog: on('fog'),
      embers: on('embers'),
      sparks: on('sparks'),
      graveyard: on('graveyard'),
      lightning: on('lightning'),
      glow: on('glow'),
      color: d.color || '#e8892b'
    };
  }

  /* ---------- Toile d'araignée (coin haut-gauche, retournée par CSS pour les autres coins) ---------- */
  function webSVG(size, seed) {
    var rnd = seeded(seed);
    var spokes = 6 + Math.floor(rnd() * 2);
    var rings = 5 + Math.floor(rnd() * 2);
    var pts = [];
    var i;
    var k;
    for (k = 1; k <= rings; k++) {
      var ring = [];
      for (i = 0; i <= spokes; i++) {
        var angle = ((i / spokes) * Math.PI) / 2;
        var radius = size * (k / (rings + 0.4)) * (0.94 + rnd() * 0.12);
        ring.push([radius * Math.cos(angle), radius * Math.sin(angle)]);
      }
      pts.push(ring);
    }
    var d = '';
    var spokePaths = '';
    for (i = 0; i <= spokes; i++) {
      var last = pts[rings - 1][i];
      spokePaths += '<path class="tm-hw-spoke" d="M0 0 L' + last[0].toFixed(1) + ' ' + last[1].toFixed(1) + '"/>';
    }
    var ringPaths = '';
    var drops = '';
    for (k = 0; k < rings; k++) {
      d = 'M' + pts[k][0][0].toFixed(1) + ' ' + pts[k][0][1].toFixed(1);
      for (i = 1; i <= spokes; i++) {
        var a = pts[k][i - 1];
        var b = pts[k][i];
        var cx = ((a[0] + b[0]) / 2) * 0.8;
        var cy = ((a[1] + b[1]) / 2) * 0.8;
        d += ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + b[0].toFixed(1) + ' ' + b[1].toFixed(1);
        if (rnd() > 0.93) {
          drops += '<circle cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="1.6"/>';
        }
      }
      ringPaths += '<path class="tm-hw-ring" d="' + d + '"/>';
    }
    return (
      '<svg viewBox="0 0 ' + size + ' ' + size + '" aria-hidden="true" focusable="false">' +
      spokePaths + ringPaths + drops + '</svg>'
    );
  }

  /* ---------- Araignée ---------- */
  var SPIDER_SVG =
    '<svg viewBox="0 0 40 44" aria-hidden="true" focusable="false">' +
    '<g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M14 20 L5 12 L2 20"/><path d="M13 24 L3 22 L1 31"/><path d="M13 28 L4 31 L3 40"/><path d="M15 32 L8 38 L8 44"/>' +
    '<path d="M26 20 L35 12 L38 20"/><path d="M27 24 L37 22 L39 31"/><path d="M27 28 L36 31 L37 40"/><path d="M25 32 L32 38 L32 44"/>' +
    '</g>' +
    '<ellipse cx="20" cy="28" rx="9" ry="10" fill="currentColor"/>' +
    '<circle cx="20" cy="15" r="5.5" fill="currentColor"/>' +
    '<circle class="tm-hw-eye" cx="18" cy="14.5" r="1.3"/><circle class="tm-hw-eye" cx="22" cy="14.5" r="1.3"/>' +
    '<path d="M17 26 L20 32 L23 26 Z" fill="#e8892b" opacity="0.9"/>' +
    '</svg>';

  function spiderNode(x, y, opts) {
    var spider = el('div', 'tm-hw-spider', '<div class="tm-hw-thread"></div>' + SPIDER_SVG);
    spider.style.left = x + 'px';
    spider.style.top = y + 'px';
    spider.style.setProperty('--tm-h1', opts.h1 + 'px');
    spider.style.setProperty('--tm-h2', opts.h2 + 'px');
    spider.style.setProperty('--tm-size', opts.size + 'px');
    spider.style.setProperty('--tm-dur', opts.dur + 's');
    spider.style.setProperty('--tm-sway', rand(3.5, 6) + 's');
    spider.style.setProperty('--tm-delay', '-' + rand(0, opts.dur) + 's');
    return spider;
  }

  /* ---------- Chauve-souris ---------- */
  var BAT_SVG =
    '<svg viewBox="0 0 100 60" aria-hidden="true" focusable="false">' +
    '<path class="tm-hw-wing-l" fill="currentColor" d="M46 27 C34 10 16 8 2 14 C8 18 8 24 13 28 C17 24 22 26 26 33 C30 29 36 31 41 40 C43 36 45 32 46 27 Z"/>' +
    '<path class="tm-hw-wing-r" fill="currentColor" d="M54 27 C66 10 84 8 98 14 C92 18 92 24 87 28 C83 24 78 26 74 33 C70 29 64 31 59 40 C57 36 55 32 54 27 Z"/>' +
    '<ellipse cx="50" cy="32" rx="6" ry="10" fill="currentColor"/>' +
    '<circle cx="50" cy="21" r="5" fill="currentColor"/>' +
    '<path d="M46 18 L44 8 L49 15 Z M54 18 L56 8 L51 15 Z" fill="currentColor"/>' +
    '<circle cx="48" cy="21" r="1.1" fill="#e8892b"/><circle cx="52" cy="21" r="1.1" fill="#e8892b"/>' +
    '</svg>';

  /* ---------- Sorcière sur son balai (regarde vers la droite) ---------- */
  var WITCH_SVG =
    '<svg viewBox="-10 -12 210 112" aria-hidden="true" focusable="false">' +
    '<path d="M22 76 L176 58" stroke="#4a3320" stroke-width="4.5" stroke-linecap="round" fill="none"/>' +
    '<path d="M28 76 C14 62 4 62 -6 66 C0 72 -2 80 -6 88 C6 90 16 88 28 78 Z" fill="#8a5a2b" stroke="#5e3b18" stroke-width="1.5"/>' +
    '<rect x="26" y="70" width="5" height="12" rx="2" fill="#33201a" transform="rotate(-6 28 76)"/>' +
    '<g fill="#17180f" stroke="#17180f" stroke-linecap="round" stroke-linejoin="round">' +
    '<path class="tm-hw-cape" d="M96 52 C76 52 60 60 50 76 C68 72 82 70 100 68 Z"/>' +
    '<path d="M92 66 C88 44 100 38 112 42 C124 46 128 60 124 66 Z"/>' +
    '<path d="M100 66 L97 86 L106 88 M114 64 L115 86 L124 85" fill="none" stroke-width="6"/>' +
    '<path d="M117 50 L132 63" fill="none" stroke-width="5"/>' +
    '<path class="tm-hw-hair" d="M106 36 C94 38 84 44 74 56 C86 52 94 50 104 48 Z"/>' +
    '<circle cx="114" cy="33" r="9"/>' +
    '<ellipse cx="114" cy="26" rx="19" ry="4.5"/>' +
    '<path d="M102 26 C106 12 118 2 134 -10 C128 4 130 18 126 26 Z"/>' +
    '</g>' +
    '<circle cx="118" cy="33" r="1.6" fill="#e8892b"/>' +
    '</svg>';

  /* ---------- Cimetière ---------- */
  function graveyardSVG(full, ids) {
    var stones = [
      [330, 148, 0.95], [470, 138, 1.05], [720, 150, 1], [1010, 144, 1.1], [1170, 154, 0.95], [1380, 146, 1]
    ];
    var stoneSVG = '';
    stones.forEach(function (s, idx) {
      var x = s[0];
      var top = s[1];
      var w = 44 * s[2];
      var h = 215 - top;
      stoneSVG +=
        '<path d="M' + x + ' 218 V' + (top + w / 2) + ' a' + w / 2 + ' ' + w / 2 + ' 0 0 1 ' + w + ' 0 V218 Z" fill="#3a3d34" stroke="#555947" stroke-width="1.5"/>';
      if (idx % 2 === 0) {
        stoneSVG += '<path d="M' + (x + w / 2) + ' ' + (top + 12) + ' v' + h * 0.38 + ' M' + (x + w / 2 - 7) + ' ' + (top + 22) + ' h14" stroke="#6d7160" stroke-width="2.4" stroke-linecap="round" fill="none"/>';
      }
    });

    function jack(cx, cy, scale, glowClass) {
      return (
        '<g transform="translate(' + cx + ' ' + cy + ') scale(' + scale + ')">' +
        '<path d="M-3 -34 C-3 -44 4 -46 8 -44" stroke="#4b5a22" stroke-width="5" stroke-linecap="round" fill="none"/>' +
        '<ellipse cx="0" cy="0" rx="42" ry="34" fill="url(#' + ids + '-pumpkin)"/>' +
        '<ellipse cx="-22" cy="0" rx="17" ry="33" fill="none" stroke="#a24914" stroke-width="2" opacity="0.7"/>' +
        '<ellipse cx="22" cy="0" rx="17" ry="33" fill="none" stroke="#a24914" stroke-width="2" opacity="0.7"/>' +
        '<g class="tm-hw-jack-glow ' + glowClass + '" filter="url(#' + ids + '-soft)">' +
        '<path d="M-24 -10 L-10 -10 L-17 -23 Z M10 -10 L24 -10 L17 -23 Z" fill="#ffd36b"/>' +
        '<path d="M-26 8 Q-14 24 0 17 Q14 24 26 8 L20 8 L14 14 L7 8 L0 14 L-7 8 L-14 14 L-20 8 Z" fill="#ffd36b"/>' +
        '</g></g>'
      );
    }

    return (
      '<svg viewBox="0 0 1600 240" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">' +
      '<defs>' +
      '<radialGradient id="' + ids + '-pumpkin" cx="50%" cy="40%" r="65%"><stop offset="0" stop-color="#f29a3c"/><stop offset="1" stop-color="#b4531a"/></radialGradient>' +
      '<radialGradient id="' + ids + '-moon" cx="50%" cy="50%" r="50%"><stop offset="0.55" stop-color="#fff3d4"/><stop offset="1" stop-color="#fff3d4" stop-opacity="0"/></radialGradient>' +
      '<filter id="' + ids + '-soft" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="2.2"/></filter>' +
      '</defs>' +
      (full
        ? '<circle cx="1090" cy="92" r="64" fill="url(#' + ids + '-moon)" opacity="0.55"/>' +
          '<circle cx="1090" cy="92" r="34" fill="#f8ecc9"/>' +
          '<circle cx="1079" cy="84" r="6" fill="#e5d5a8"/><circle cx="1100" cy="102" r="4.5" fill="#e5d5a8"/><circle cx="1098" cy="78" r="3" fill="#e5d5a8"/>' +
          '<g class="tm-hw-ghost"><path transform="translate(640 74)" d="M0 40 C0 10 12 0 24 0 C36 0 48 10 48 40 L48 60 Q42 54 36 60 Q30 54 24 60 Q18 54 12 60 Q6 54 0 60 Z" fill="#ffffff" opacity="0.82"/>' +
          '<circle cx="652" cy="98" r="3.4" fill="#17180f"/><circle cx="668" cy="98" r="3.4" fill="#17180f"/><ellipse cx="660" cy="110" rx="4" ry="5.5" fill="#17180f"/></g>' +
          '<g transform="translate(150 0)" fill="none" stroke="#121310" stroke-linecap="round">' +
          '<path d="M110 222 C112 180 98 150 108 112" stroke-width="12"/>' +
          '<path d="M108 150 C82 140 62 122 38 120" stroke-width="7"/>' +
          '<path d="M106 136 C130 120 150 112 176 108" stroke-width="6"/>' +
          '<path d="M104 124 C92 100 82 86 70 66" stroke-width="5"/>' +
          '<path d="M108 118 C120 94 132 80 146 58" stroke-width="5"/>' +
          '<path d="M60 126 C52 112 46 108 36 104 M160 112 C166 100 172 96 182 92 M76 80 C70 74 62 72 56 70" stroke-width="3"/>' +
          '</g>'
        : '') +
      stoneSVG +
      '<path d="M0 240 V204 Q200 188 420 204 T820 200 T1220 203 T1600 198 V240 Z" fill="#121310"/>' +
      jack(560, 196, 0.85, '') +
      jack(900, 200, 1, 'tm-hw-jack-glow--2') +
      jack(1260, 198, 0.9, '') +
      '</svg>'
    );
  }

  /* ---------- Construction ---------- */
  function clear() {
    ['tm-halloween-root', 'tm-halloween-fixed'].forEach(function (id) {
      var node = document.getElementById(id);
      if (node) node.remove();
    });
    document.querySelectorAll('.tm-hw-graveyard, .tm-hw-strip, .tm-hw-spark').forEach(function (node) {
      node.remove();
    });
    if (state.stripObserver) {
      state.stripObserver.disconnect();
      state.stripObserver = null;
    }
    if (state.sparkHandler) {
      window.removeEventListener('pointermove', state.sparkHandler);
      state.sparkHandler = null;
    }
    if (state.resizeObserver) {
      state.resizeObserver.disconnect();
      state.resizeObserver = null;
    }
    clearTimeout(state.lightningTimer);
    document.documentElement.classList.remove('tm-hw-on');
  }

  function buildWebs(root, cfg, isMobile) {
    var holder = document.getElementById('tm-halloween-webs');
    if (holder) holder.remove();
    holder = el('div');
    holder.id = 'tm-halloween-webs';
    root.appendChild(holder);

    var sx = window.scrollX;
    var sy = window.scrollY;
    var docWidth = document.documentElement.clientWidth;
    var count = 0;

    function addWeb(left, top, size, flipX, flipY, seed) {
      var web = el('div', 'tm-hw-web', webSVG(Math.round(size), seed));
      web.style.left = left + 'px';
      web.style.top = top + 'px';
      web.style.width = size + 'px';
      web.style.height = size + 'px';
      var flip = (flipX ? 'scaleX(-1) ' : '') + (flipY ? 'scaleY(-1)' : '');
      if (flip) web.style.transform = flip;
      holder.appendChild(web);
    }

    function addSpider(x, top, maxDrop, size) {
      if (!cfg.spiders) return;
      var h1 = rand(18, 40);
      var h2 = Math.min(rand(70, 130), Math.max(h1 + 30, maxDrop));
      holder.appendChild(spiderNode(x, top, { h1: h1, h2: h2, size: size, dur: rand(6, 10) }));
    }

    /* Coins du haut de la page */
    var topSize = isMobile ? 84 : 190;
    if (cfg.webs) {
      addWeb(0, 0, topSize, false, false, 11);
      addWeb(docWidth - topSize, 0, topSize, true, false, 23);
    }
    addSpider(topSize * 0.62, 0, isMobile ? 60 : 78, isMobile ? 20 : 26);
    addSpider(docWidth - topSize * 0.7, 0, isMobile ? 52 : 70, isMobile ? 18 : 24);

    var targets = Array.prototype.slice.call(
      document.querySelectorAll('#MainContent > .shopify-section, footer .shopify-section')
    );

    targets.forEach(function (section, index) {
      var rect = section.getBoundingClientRect();
      if (rect.height < 150 || rect.width < 200) return;
      count += 1;
      var top = rect.top + sy;
      var maxSize = isMobile ? 130 : 230;
      var size = Math.round(Math.max(80, Math.min(rect.width * (isMobile ? 0.34 : 0.2), rect.height * 0.7, maxSize)));
      var right = count % 2 === 0;
      var left = right ? rect.right + sx - size : rect.left + sx;
      if (cfg.webs) {
        addWeb(left, top, size, right, false, 100 + index * 7);
        if (rect.height > 420 && count % 3 === 0) {
          var bsize = Math.round(size * 0.75);
          var bleft = right ? rect.left + sx : rect.right + sx - bsize;
          addWeb(bleft, top + rect.height - bsize, bsize, !right, true, 300 + index * 5);
        }
      }
      if (count % 2 === 1) {
        var spiderX = right ? left + size * 0.3 : left + size * 0.82;
        addSpider(spiderX, top, rect.height * 0.5, isMobile ? 18 : 24 + Math.round(rand(0, 6)));
      }
    });
  }

  function buildFixed(cfg, isMobile, reduced) {
    var fixed = el('div');
    fixed.id = 'tm-halloween-fixed';
    document.body.appendChild(fixed);

    if (cfg.fog) {
      fixed.appendChild(el('div', 'tm-hw-fog'));
      fixed.appendChild(el('div', 'tm-hw-fog tm-hw-fog--2'));
    }

    if (cfg.bats && !reduced) {
      var batCount = isMobile ? 2 : 4;
      for (var i = 0; i < batCount; i++) {
        var bat = el('div', 'tm-hw-bat' + (i % 2 ? ' tm-hw-bat--rtl' : ''));
        bat.innerHTML = '<div class="tm-hw-bat-inner">' + BAT_SVG + '</div>';
        bat.style.setProperty('--tm-top', rand(6, 46).toFixed(1) + 'vh');
        bat.style.setProperty('--tm-size', Math.round(isMobile ? rand(26, 42) : rand(34, 64)) + 'px');
        bat.style.setProperty('--tm-cycle', rand(18, 30).toFixed(1) + 's');
        bat.style.setProperty('--tm-delay', rand(0, 12).toFixed(1) + 's');
        fixed.appendChild(bat);
      }
    }

    if (cfg.witch && !reduced) {
      var witch = el('div', 'tm-hw-witch');
      var trail = '';
      for (var t = 0; t < 7; t++) {
        trail += '<span class="tm-hw-trail" style="--tm-i:' + t + '"></span>';
      }
      witch.innerHTML = '<div class="tm-hw-witch-inner">' + WITCH_SVG + trail + '</div>';
      witch.style.setProperty('--tm-size', (isMobile ? 104 : 170) + 'px');
      witch.style.setProperty('--tm-top', (isMobile ? 20 : 16) + 'vh');
      fixed.appendChild(witch);
    }

    if (cfg.embers && !reduced) {
      var emberCount = isMobile ? 8 : 18;
      for (var j = 0; j < emberCount; j++) {
        var ember = el('span', 'tm-hw-ember');
        ember.style.setProperty('--tm-x', rand(2, 98).toFixed(1) + '%');
        ember.style.setProperty('--tm-size', rand(3, 7).toFixed(1) + 'px');
        ember.style.setProperty('--tm-dur', rand(11, 20).toFixed(1) + 's');
        ember.style.setProperty('--tm-delay', '-' + rand(0, 16).toFixed(1) + 's');
        ember.style.setProperty('--tm-drift', Math.round(rand(-50, 50)) + 'px');
        fixed.appendChild(ember);
      }
    }
  }

  /* ---------- Éclairs ----------
     Un éclair frappe toutes les 6 à 14 secondes. Jamais plus de deux éclairs par seconde
     (règle d'accessibilité contre les flashs), et rien du tout si la personne a demandé "moins de mouvement". */
  function boltPath(rng, x, y, endY, spread) {
    var points = [[x, y]];
    while (y < endY) {
      y += 14 + rng() * 34;
      x += (rng() - 0.5) * spread;
      points.push([x, Math.min(y, endY)]);
    }
    return points;
  }

  function pointsToPath(points) {
    return points
      .map(function (p, i) {
        return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1);
      })
      .join(' ');
  }

  function strike(fixed, isMobile, flashPeak) {
    var w = window.innerWidth;
    var h = window.innerHeight;
    var rng = seeded((Math.random() * 4294967296) >>> 0);
    var x0 = w * (0.1 + rng() * 0.8);
    var endY = h * (0.45 + rng() * 0.4);
    var spread = isMobile ? 48 : 70;
    var main = boltPath(rng, x0, -10, endY, spread);

    var branches = '';
    main.forEach(function (p, i) {
      if (i < 2 || i > main.length - 3 || rng() > 0.4) return;
      var dir = rng() > 0.5 ? 1 : -1;
      var branchPoints = [[p[0], p[1]]];
      var bx = p[0];
      var by = p[1];
      var steps = 2 + Math.floor(rng() * 3);
      for (var s = 0; s < steps; s++) {
        bx += dir * (14 + rng() * 34);
        by += 12 + rng() * 30;
        branchPoints.push([bx, by]);
      }
      branches += '<path class="tm-hw-bolt-branch" d="' + pointsToPath(branchPoints) + '"/>';
    });

    var d = pointsToPath(main);
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'tm-hw-bolt');
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = '<path class="tm-hw-bolt-glow" d="' + d + '"/><path class="tm-hw-bolt-core" d="' + d + '"/>' + branches;

    var flash = el('div', 'tm-hw-flash');
    flash.style.setProperty('--tm-fx', ((x0 / w) * 100).toFixed(1) + '%');
    fixed.appendChild(flash);
    fixed.appendChild(svg);

    var shape = [
      { opacity: 0, offset: 0 },
      { opacity: 1, offset: 0.05 },
      { opacity: 0.45, offset: 0.14 },
      { opacity: 0.9, offset: 0.22 },
      { opacity: 0.25, offset: 0.45 },
      { opacity: 0, offset: 1 }
    ];
    var scaled = shape.map(function (k) {
      return { opacity: k.opacity * flashPeak, offset: k.offset };
    });
    var done = function () {
      flash.remove();
      svg.remove();
    };
    var anim = svg.animate(shape, { duration: 900, easing: 'ease-out' });
    flash.animate(scaled, { duration: 900, easing: 'ease-out' });
    anim.onfinish = done;
    setTimeout(done, 1500);
  }

  function buildLightning(cfg, isMobile, reduced) {
    if (!cfg.lightning || reduced || typeof Element.prototype.animate !== 'function') return;
    var fixed = document.getElementById('tm-halloween-fixed');
    if (!fixed) return;
    var peak = isMobile ? 0.5 : 0.62;

    function schedule(delay) {
      state.lightningTimer = setTimeout(function () {
        if (!document.hidden) {
          strike(fixed, isMobile, peak);
          /* parfois un second éclair, au moins 0,9 s après le premier */
          if (Math.random() < 0.4) {
            setTimeout(function () {
              if (!document.hidden) strike(fixed, isMobile, peak * 0.8);
            }, 950 + Math.random() * 400);
          }
        }
        schedule(6000 + Math.random() * 8000);
      }, delay);
    }
    schedule(2500);
  }

  function buildSparks(cfg, reduced) {
    if (!cfg.sparks || reduced || !window.matchMedia('(pointer: fine)').matches) return;
    state.sparkHandler = function (event) {
      var now = performance.now();
      if (now - state.lastSpark < 45) return;
      state.lastSpark = now;
      if (document.querySelectorAll('.tm-hw-spark').length > 28) return;
      var spark = el('span', 'tm-hw-spark');
      spark.style.left = event.clientX + 'px';
      spark.style.top = event.clientY + 'px';
      spark.style.setProperty('--tm-size', Math.round(rand(6, 12)) + 'px');
      spark.style.setProperty('--tm-dx', Math.round(rand(-20, 20)) + 'px');
      spark.style.setProperty('--tm-dy', Math.round(rand(18, 42)) + 'px');
      spark.addEventListener('animationend', function () {
        spark.remove();
      });
      document.body.appendChild(spark);
    };
    window.addEventListener('pointermove', state.sparkHandler, { passive: true });
  }

  function buildGraveyard(cfg) {
    if (!cfg.graveyard) return;
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return;
    var graveyard = el('div', 'tm-hw-graveyard', graveyardSVG(true, 'tm-hw-g'));
    wrapper.appendChild(graveyard);

    /* Bande toujours visible en bas de l'écran pendant qu'on défile, qui s'efface quand le grand cimetière arrive */
    var strip = el('div', 'tm-hw-strip', graveyardSVG(false, 'tm-hw-s'));
    document.body.appendChild(strip);
    if (typeof IntersectionObserver === 'function') {
      state.stripObserver = new IntersectionObserver(function (entries) {
        strip.classList.toggle('is-hidden', entries[0].isIntersecting);
      });
      state.stripObserver.observe(graveyard);
    }
  }

  function init() {
    clear();
    var cfg = readConfig();
    if (!cfg) return;

    var root = el('div');
    root.id = 'tm-halloween-root';
    document.body.appendChild(root);

    document.documentElement.style.setProperty('--tm-hw-glow', cfg.color);
    if (cfg.glow) document.documentElement.classList.add('tm-hw-on');

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    buildGraveyard(cfg);
    buildFixed(cfg, isMobile, reduced);
    buildLightning(cfg, isMobile, reduced);
    buildSparks(cfg, reduced);

    function rebuild() {
      buildWebs(root, cfg, window.matchMedia('(max-width: 749px)').matches);
    }
    rebuild();

    if (typeof ResizeObserver === 'function') {
      state.resizeObserver = new ResizeObserver(function () {
        clearTimeout(state.resizeTimer);
        state.resizeTimer = setTimeout(rebuild, 300);
      });
      state.resizeObserver.observe(document.body);
    }
    window.addEventListener('load', rebuild, { once: true });
  }

  window.tmHalloweenInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#tm-halloween-config')) init();
  });
  document.addEventListener('shopify:section:unload', function () {
    if (!document.getElementById('tm-halloween-config')) clear();
  });
})();
